import { render, staticRenderFns } from "./studyCourseKd.vue?vue&type=template&id=895e11e2&scoped=true&"
import script from "./studyCourseKd.vue?vue&type=script&lang=js&"
export * from "./studyCourseKd.vue?vue&type=script&lang=js&"
import style0 from "./studyCourseKd.vue?vue&type=style&index=0&id=895e11e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895e11e2",
  null
  
)

export default component.exports